import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import EmployeeRegisterPage from "./pages/EmployeeRegisterPage";
import SuperAdminDashboard from "./pages/SuperAdminDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import EmployeeDashboard from "./pages/EmployeeDashboard";
import InstallAppPage from "./pages/InstallAppPage";
import AffiliateLoginPage from "./pages/AffiliateLoginPage";
import AffiliateDashboard from "./pages/AffiliateDashboard";
import PWAInstallPrompt from "./components/PWAInstallPrompt";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import "./App.css";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-sky-500"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to={user.role === "admin" ? "/admin" : "/dashboard"} replace />;
  }

  return children;
};

function AppRoutes() {
  const { user } = useAuth();

  const getRedirectPath = () => {
    if (!user) return "/";
    if (user.role === "superadmin") return "/superadmin";
    if (user.role === "admin") return "/admin";
    return "/dashboard";
  };

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/instalar" element={<InstallAppPage />} />
      <Route path="/app" element={<InstallAppPage />} />
      <Route path="/master" element={<Navigate to="/login?role=superadmin" replace />} />
      <Route 
        path="/login" 
        element={user ? <Navigate to={getRedirectPath()} replace /> : <LoginPage />} 
      />
      <Route 
        path="/register" 
        element={user ? <Navigate to={getRedirectPath()} replace /> : <RegisterPage />} 
      />
      <Route 
        path="/register/employee" 
        element={user ? <Navigate to={getRedirectPath()} replace /> : <EmployeeRegisterPage />} 
      />
      <Route
        path="/superadmin/*"
        element={
          <ProtectedRoute allowedRoles={["superadmin"]}>
            <SuperAdminDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/*"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/*"
        element={
          <ProtectedRoute allowedRoles={["employee"]}>
            <EmployeeDashboard />
          </ProtectedRoute>
        }
      />
      <Route path="/indica/login" element={<AffiliateLoginPage />} />
      <Route path="/indica" element={<AffiliateDashboard />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
